var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5586 14.2259C11.5586 14.2259 13.126 16.6565 15.6284 16.6565C15.985 16.6565 16.3415 16.6172 16.6873 16.5368C16.9997 16.4642 17.3022 16.3584 17.5894 16.2247C17.8522 16.1021 18.1019 15.9557 18.3354 15.7916C18.5455 15.644 18.7425 15.482 18.9269 15.3085C19.2411 15.0133 19.5057 14.679 19.7568 14.3386C19.814 14.2607 19.8785 14.1844 19.9218 14.0991C19.9903 13.963 19.9587 13.8174 19.8632 13.6989C19.8632 13.6989 18.1785 11.3252 15.6762 11.3252C12.8677 11.3252 11.5 13.7505 11.5 13.7505",
    stroke: "#26445A",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6627 14.3802C11.6055 14.2945 11.541 14.2106 11.4977 14.1168C11.4292 13.9671 11.4608 13.8071 11.5563 13.6768",
    stroke: "#26445A",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7299,
    cy: 13.9907,
    r: 0.961182,
    stroke: "#26445A",
    strokeWidth: 1.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8828 11.0049L12.8598 12.2261",
    stroke: "#26445A",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6172 9.85938L14.8614 11.3248",
    stroke: "#26445A",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3067 9.85938L17.0625 11.3248",
    stroke: "#26445A",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7504 11.3252L18.7734 12.3022",
    stroke: "#26445A",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1589 8.33684V6.37147C19.1589 5.10921 18.1357 4.08594 16.8734 4.08594H3.35585C2.09358 4.08594 1.07031 5.10921 1.07031 6.37148V14.3708C1.07031 15.6331 2.09358 16.6564 3.35585 16.6564L9.21526 16.6564",
    stroke: "#26445A",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/Preview.6d1980ba81b88c016b70ac0f1de4c4f2.svg";
export { ForwardRef as ReactComponent };